import { BehaviorSubject } from 'rxjs';

import ProductRepository from '../pages/stock/products/product.repository';
import { CacheModel } from './cache.model';
import { Product } from '../pages/stock/products/product.model';

export default class ProductCache {
  private repository: ProductRepository;

  private _cache = new BehaviorSubject<CacheModel>(new CacheModel(null, 5));
  private get cache() {
    return this._cache.value;
  }

  constructor() {
    this.repository = new ProductRepository();
  }

  invalidate() {
    this._cache.next(new CacheModel(null, 0));
  }

  async getAll(): Promise<Product[]> {
    if (this.cache.valid()) return this.cache.data as Product[];
    const products = await this.repository.getAll();
    this._cache.next(new CacheModel(products, 10));
    return products;
  }

  getById(id: string): Product | undefined {
    if (this.cache.valid()) {
      const products = this.cache.data as Product[];
      return products.find(product => product.id === id);
    }
    this.getAll();
  }
}
